<template>
  <div class="crud">
    <DataTable :value="entities" selectionMode="single" :selection.sync="newQuotation" @row-select="onRowSelect"
               dataKey="_id" :paginator="true" :rows="15">
      <Column field="title" :header="$t('crud.quotation.labels.title')"></Column>
      <Column field="description" :header="$t('crud.quotation.labels.description')"></Column>
      <Column field="tjm" :header="$t('crud.quotation.labels.tjm')"></Column>
      <Column field="company" :header="$t('crud.quotation.labels.company')"></Column>
      <Column field="duration" :header="$t('crud.quotation.labels.duration')"></Column>
      <Column field="discount" :header="$t('crud.quotation.labels.discount')"></Column>
      <template #footer>
        <Button :label="$t('shared.actions.create')" icon="pi pi-plus" @click="createQuotation" class="p-button-primary" />
      </template>
    </DataTable>

    <Dialog :visible.sync="dialogVisible" :style="{width: '400px'}" :modal="true">
      <template #header>
        <span>{{ $t('crud.quotation.modals.titles.' + action) }}</span>
      </template>
      <div>
        <label for="title">{{ $t('crud.quotation.labels.title') }}</label>
        <input id="title" v-model="newQuotation.title" name="name" type="text">
      </div>
      <div>
        <label for="description">{{ $t('crud.quotation.labels.description') }}</label>
        <input id="description" v-model="newQuotation.description" name="name" type="text">
      </div>
      <div>
        <label for="tjm">{{ $t('crud.quotation.labels.tjm') }}</label>
        <input id="tjm" min="0" v-model.number="newQuotation.tjm" name="amount" type="number">
      </div>
      <div>
        <label for="company">{{ $t('crud.quotation.labels.company') }}</label>
        <input id="company" v-model="newQuotation.company" name="name" type="text">
      </div>
      <div>
        <label for="duration">{{ $t('crud.quotation.labels.duration') }}</label>
        <input id="duration" min="0" v-model.number="newQuotation.duration" name="amount" type="number">
      </div>
      <div>
        <label for="discount">{{ $t('crud.quotation.labels.discount') }}</label>
        <input id="discount" min="0" v-model.number="newQuotation.discount" name="duration" type="number">
      </div>
      <template #footer>
        <Button v-if="action === 'update'" :label="$t('shared.actions.delete')" icon="pi pi-trash" @click="deleteQuotation" class="p-button-danger"></Button>
        <Button :label="$t('shared.actions.save')" icon="pi pi-check" @click="saveQuotation" class="p-button-success"></Button>
        <Button :label="$t('shared.actions.cancel')" icon="pi pi-times" @click="cancelEdit" class="p-button-secondary"></Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Quotation from "../models/quotation.model";
  import Dialog from "primevue/components/dialog/Dialog";
  import Button from 'primevue/button';

  export default {
    name: 'Crud',
    components: {
      Dialog,
      DataTable,
      Column,
      Button
    },
    props: {},
    data: () => {
      return {
        newQuotation: {},
        dialogVisible: false,
        action: '',
        entityName: ''
      }
    },
    computed: {
      entities() {
        return this.$store.state.quotations;
      }
    },
    methods: {
      onRowSelect: function(event) {
        this.action = 'update';
        this.newQuotation = {...event.data};
        this.dialogVisible = true;
      },
      createQuotation: function() {
        this.action = 'create';
        this.resetNewQuotation();
        this.dialogVisible = true;
      },
      deleteQuotation: function() {
        this.$store.dispatch('removeQuotation', this.newQuotation).then((succeed) => {
          if (succeed) {
            this.$toast.add({severity: 'success', summary: this.$t('crud.quotationtoasts_msg.summary.delete'),
                             detail: this.$t('crud.quotationtoasts_msg.success.delete'), life: 3000});
            this.dialogVisible = false;
            this.resetNewQuotation();
          } else {
            this.$toast.add({severity: 'error', summary: this.$t('crud.quotationtoasts_msg.summary.delete'),
                             detail: this.$t('crud.quotationtoasts_msg.fail.delete'), life: 3000});
          }
        });
      },
      saveQuotation: function () {
        if (this.$isNotEmpty(this.newQuotation.title)
          && this.$isNotEmpty(this.newQuotation.description)
          && this.$isNotEmpty(this.newQuotation.company)
          && this.$isNotEmpty(this.newQuotation.duration) && !isNaN(this.newQuotation.duration)
          && this.$isNotEmpty(this.newQuotation.discount) && !isNaN(this.newQuotation.discount)
          && this.$isNotEmpty(this.newQuotation.tjm) && !isNaN(this.newQuotation.tjm)
        ) {
          let dispatch = 'postQuotation';
          if (this.action === 'update') {
            dispatch = 'updateQuotation';
          }

          this.$store.dispatch(dispatch, this.newQuotation).then((succeed) => {
            if (succeed) {
              this.$toast.add({severity: 'success', summary: this.$t('crud.quotationtoasts_msg.summary.save'),
                               detail: this.$t('crud.quotationtoasts_msg.success.save'), life: 3000});
              this.dialogVisible = false;
              this.resetNewQuotation();
            } else {
              this.$toast.add({severity: 'error', summary: this.$t('crud.quotationtoasts_msg.summary.save'),
                               detail: this.$t('crud.quotationtoasts_msg.fail.save'), life: 3000});
            }
          });
        } else {
          this.$toast.add({severity: 'error', summary: this.$t('crud.quotationtoasts_msg.summary.validation'),
                           detail: this.$t('crud.quotationtoasts_msg.validation.fieldsMissing'), life: 3000
          });
        }
      },
      resetNewQuotation: function () {
        this.newQuotation = new Quotation({});
      },
      cancelEdit: function () {
        this.dialogVisible = false;
        this.newQuotation = new Quotation({});
      }
    },
    created: function () {
      this.$store.dispatch('fetchAll');
      this.resetNewQuotation();
      this.entityName = this.$t('crud.quotationquotation')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .crud {
  }
</style>
